import { FunctionalComponent } from 'preact';
import { useEffect, useMemo, useState } from 'preact/compat';
import { Icon } from './components/Icon/icon';
import { IComment, QuestionContainer } from './components/QuestionsContainer';
import { MetadataContainer } from './components/MetadataContainer';
import { Toggler } from './components/Toggler';
import { API_URL, ROOT_SELECTOR } from './constants';

import './style.css';
import './styles/container.css';
import './styles/widget.css';
import { cn, isSharpenOrLocal, requestOptions } from './utilities';
import { WidgetContext } from './widget.context';

export interface ISharpenData {
  planId?: number;
  questions?: IComment[];
}

export interface ISessionState {
  tutorialSessionId?: number;
  tutorialSessionPlanId?: number;
}

export interface IRootDataset {
  course?: string;
  ctId?: string;
  token?: string;
}

export const Widget: FunctionalComponent = () => {
  const [sharpenData, setSharpenData] = useState<ISharpenData>({});
  const [session, setSession] = useState<ISessionState>({});
  const [isOpen, setIsOpen] = useState(false);
  const [isRefetch, setIsRefetch] = useState(true);
  const toggle = () => setIsOpen(!isOpen);

  const rootData = useMemo<IRootDataset>(() => {
    const root = document.querySelector<HTMLElement>(ROOT_SELECTOR);
    return root ? Object.assign<IRootDataset, DOMStringMap>({}, root.dataset) : {};
  }, []);

  useEffect(() => {
    if (!rootData) {
      throw new Error('Root data is not specified!');
    }

    if (!isRefetch) {
      return;
    }
    setIsRefetch(false);

    if (isSharpenOrLocal) {
      fetch(`${API_URL}/tutorial-session/current-session-questions`, requestOptions(rootData.token))
        .then((res) => res.json())
        .then((res) => {
          if (res.data) {
            setSharpenData(res.data);
            setSession(() => ({
              tutorialSessionPlanId: res.data.planId,
            }));
          }
        });
    } else {
      // fetch(`${API_URL}/tutorial-session/course/${rootData.course}/getNextSessionId`, requestOptions(rootData.token))
      //   .then((res) => res.json())
      //   .then((res) => setSession(res.data));

      // ToDo:: Test data for test
        setSession({
          tutorialSessionId: 1,
          tutorialSessionPlanId: 1
        });        
    }
  }, [rootData, isRefetch]);

  return (
    <WidgetContext.Provider value={{ session, rootData, sharpenData }}>
      <div class={cn('cw-widget', isOpen ? 'cw-widget--shown' : '')}>
        <Toggler onClick={toggle} />
        <div className="cw-scroll-container">
          <div class="cw-widget__header">
            <h1>Next Tutor Session</h1>
            <Icon icon="refresh" width="16px" height="16px" onClick={() => setIsRefetch(true)} />
          </div>
          {/* <MetadataContainer class="cw-widget__container" /> */}
          <QuestionContainer class="cw-widget__container cw-comments__container" />
        </div>
      </div>
    </WidgetContext.Provider>
  );
};
